import './navigation';
import './header';
// import './ajax-add-to-cart';
import './products-loop-filtering';
import './toggle-thumbnail';
import './quiz';
import './pricing-img';
